<script>
export default {
    name: 'HereDomMarker',
    inject: ['map', 'ui', 'group'],
    props: {
        lat: {
            type: Number,
            required: true
        },
        lng: {
            type: Number,
            required: true
        },
        registrationNumber: {
            type: String
        },
        registrationColor: {
            type: String
        }
    },
    data () {
        return {
            domMarker: null
        }
    },
    computed: {
        latLng () {
            return `${this.lat}|${this.lng}`
        }
    },
    watch: {
        latLng (newVal, oldVal) {
            const [oldLat, oldLng] = oldVal.split('|')
            const [newLat, newLng] = newVal.split('|')
            if ((null != newLat && null != newLng) && (oldLat !== newLat && oldLng !== newLng)) {
                this.updateRegistrationLocation()
            }
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.createRegistrationNumberMarker()
        })
    },
    beforeDestroy () {
        this.removeRegistration(false)
    },
    methods: {
        createRegistrationNumberMarker () {
            // Style of registration number
            const outerElement = document.createElement('div');
            const innerElement = document.createElement('div');

            outerElement.style.userSelect = 'none';
            outerElement.style.webkitUserSelect = 'none';
            outerElement.style.msUserSelect = 'none';
            outerElement.style.mozUserSelect = 'none';
            outerElement.style.cursor = 'default';

            const registrationColor = this.resolveColor(this.registrationColor)

            innerElement.style.color = registrationColor;
            innerElement.style.backgroundColor = '#fff';
            innerElement.style.border = `1px solid ${registrationColor}`;
            innerElement.style.borderRadius = '6px';
            innerElement.style.font = 'normal 12px arial';
            innerElement.style.textTransform = 'uppercase';
            innerElement.style.boxShadow = '0 1px 6px rgb(0 0 0 / 30%)';

            innerElement.style.paddingTop = '5px';
            innerElement.style.paddingLeft = '5px';
            innerElement.style.paddingRight = '5px';
            innerElement.style.paddingBottom = '5px';
            innerElement.style.width = 'max-content';

            // add negative margin to inner element
            // to move the anchor to center of the div
            innerElement.style.marginTop = '-27px';
            innerElement.style.marginLeft = '-50%';

            outerElement.appendChild(innerElement);

            // Add text to the DOM element
            innerElement.innerHTML = this.registrationNumber;

            //add hover
            function changeOpacity (evt) {
                evt.target.style.opacity = 1;
            };

            function changeOpacityToOne (evt) {
                evt.target.style.opacity = 1;
            };

            //create dom icon and add/remove opacity listeners
            const domIcon = new H.map.DomIcon(outerElement, {
                // the function is called every time marker enters the viewport
                onAttach: function (clonedElement, domIcon, domMarker) {
                    clonedElement.addEventListener('mouseover', changeOpacity);
                    clonedElement.addEventListener('mouseout', changeOpacityToOne);
                },
                // the function is called every time marker leaves the viewport
                onDetach: function (clonedElement, domIcon, domMarker) {
                    clonedElement.removeEventListener('mouseover', changeOpacity);
                    clonedElement.removeEventListener('mouseout', changeOpacityToOne);
                }
            });

            // Marker for tracking Vehicles
            const LocationMarker = new H.map.DomMarker({ lat: this.lat, lng: this.lng }, {
                icon: domIcon
            });
            this.domMarker = LocationMarker

            const target = null != this.group() ? this.group() : this.map()

            target.addObject(LocationMarker)
        },

        resolveColor () {
            switch (this.registrationColor) {
                case 'online': return '#aed51b'
                case 'offline': return '#fe2e58'
                case 'inactive': return '#707070'
            }
        },

        updateRegistrationLocation () {
            if (null == this.domMarker) return
            this.domMarker.setGeometry({ lat: this.lat, lng: this.lng })
        },

        removeRegistration (shouldUpdateState = true) {
            if (null == this.domMarker) return

            if (null == this.map() && null == this.group()) return

            const target = null != this.group() ? this.group() : this.map()
            if (null != target) {
                target.removeObject(this.domMarker)
            }

            if (shouldUpdateState) {
                this.domMarker = null
            }
        }
    },

    render () {
        return null
    }
}
</script>
